import { Component, OnInit } from '@angular/core'
import { Input } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableSourceSummary } from 'src/app/models/latest-aggregate-amounts.model'
import {
  getInstagramFollowers,
  getLoading,
} from 'src/app/selectors/latest-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByInstagramFollowers,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-instagram-followers-count',
    templateUrl: './aggregated-amounts-instagram-followers-count.component.html',
    styleUrls: ['./aggregated-amounts-instagram-followers-count.component.scss'],
    standalone: false
})
export class AggregatedAmountsInstagramFollowersCountComponent implements OnInit {
  instagramFollowersCountModels$: Observable<CountableSourceSummary[]>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  @Input() url: string

  ngOnInit() {
    this.instagramFollowersCountModels$ = this.store.select(getInstagramFollowers)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByInstagramFollowers)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
